import React from 'react';

import {Table, Button, message} from 'antd';
import type {TableColumnsType} from 'antd';
import {useUnblockShip} from 'hooks/shop/useGetShop';
interface Ipros {
  data?: [];
  shopId: string;
}

export const BlockList: React.FC<Ipros> = ({data, shopId}) => {
  const {mutateAsync} = useUnblockShip();
  const handleSubmit = async (shipId: string) => {
    try {
      await mutateAsync({shopId, shipId});
      message.success('Thao tác thành công');
    } catch (error) {}
  };
  const columns: TableColumnsType = [
    {
      title: 'Tên tài xế',
      dataIndex: 'name',
      key: 'name',
      width: 150,
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'user',
      key: 'numberPhone',
      align: 'center',
      width: 140,
      render: data => {
        return <p className="whitespace-nowrap">{data?.numberPhone}</p>;
      },
    },
    {
      title: 'Biển số xe',
      dataIndex: 'vehicleBKS',
      key: 'vehicleBKS',
      align: 'center',
      width: 130,
      render: data => <span className="whitespace-nowrap">{data}</span>,
    },
    {
      title: 'Tên xe',
      dataIndex: 'vehicleName',
      key: 'vehicleName',
      align: 'center',
      width: 130,
      render: data => <span className="whitespace-nowrap">{data}</span>,
    },
    {
      title: 'Thao tác',
      dataIndex: '',
      key: 'action',
      align: 'center',
      width: 120,
      render: (record: any) => {
        return (
          <Button
            className="!border-white	 bg-[#2bec82] hover:!bg-[#2bec82] !text-white !font-medium"
            onClick={() => handleSubmit(record?._id)}>
            Unblock
          </Button>
        );
      },
    },
  ];
  return <Table columns={columns} dataSource={data} scroll={{x: 'max-content'}} />;
};
